import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';

import actions from '../actions';
import UserAPI from '../apis/user';
import spreeStore from '../store';
import APP_ROUTES from '../constants/app-routes';
import translations from '../../translations/app-translations';

const UserUtils = {
    isLoggedIn: () => {
        const { user } = spreeStore.getState();
        return user && user.id;
    },
    /**
     * Log in the user and handle feedback error if fails. If you need custom callbacks you can hook them to the promise.
     * @param {object} formData
     * @param {string} locale
     * @returns Promise
     */
    signUp: (formData, locale, logoutOnFail = true) => {
        spreeStore.dispatch(actions.displayLoader());

        // TODO: Remember Me
        const { email, password } = formData.user;

        return UserAPI.loginByCode({ email, otp_code: password }).then(
            (response) => {
                spreeStore.dispatch(actions.hideLoader());
                spreeStore.dispatch(actions.login(response.body, locale));
                return Promise.resolve(response);
            },
            () => {
                toastr.error(translations[locale]['auth-failed'], translations[locale]['invalid-user-password']);
                if (logoutOnFail) {
                    spreeStore.dispatch(actions.logout());
                }
                spreeStore.dispatch(actions.hideLoader());
                return Promise.reject();
            },
        );
    },

    sendEmail: (email, locale, logoutOnFail = true) => {
        UserAPI.sendCodeByEmail({ email }).then(
            (response) => {
                toastr.info(translations[locale].code, translations[locale]['code-send-successfully']);
                return Promise.resolve(response);
            },
            () => {
                toastr.error(translations[locale]['auth-failed'], translations[locale]['invalid-email-code']);
                if (logoutOnFail) {
                    spreeStore.dispatch(actions.logout());
                }
                spreeStore.dispatch(actions.hideLoader());
                return Promise.reject();
            },
        );
    },
    /**
     * When a user login, and there is a order from before this process, the order is asynchronously associated to the user account.
     * A maximum time of 20 seconds is expected for the association to be completed.
     * @returns {Promise<unknown>} It waits until the order is successfully associated to the user account.
     */
    subscribeToAssociateOrderLogin: () => new Promise((resolve, reject) => {
        let unsubscribeStore;
        let timeout;
        const millisecondsTimeOut = 20000;

        const clearPromise = () => {
            if (unsubscribeStore) {
                unsubscribeStore();
            }
            if (timeout) {
                clearTimeout(timeout);
            }
        };

        timeout = setTimeout(() => {
            if (unsubscribeStore) {
                unsubscribeStore();
                reject();
            }
        }, millisecondsTimeOut);

        unsubscribeStore = spreeStore.subscribe(() => {
            try {
                const { user, order } = spreeStore.getState();
                if (user && order) {
                    const { user: userOrder } = order;
                    if (Object.keys(user).length > 0 && Object.keys(userOrder).length > 0 && user.id === userOrder.id) {
                        resolve();
                        clearPromise();
                    }
                } else {
                    reject();
                    clearPromise();
                }
            } catch (error) {
                reject();
                clearPromise();
            }
        });
    }),
};

export default UserUtils;



/** WEBPACK FOOTER **
 ** ./src/services/user-utils.js
 **/